<template>
  <b-modal
    title="Template de fiche"
    :modal-class="'base-modal'"
    centered
    ref="templateNameModal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
  >
    <b-container fluid>
      <div v-if="this.data" class="text-edit">
        <h2 class="sub-title">Nom de la template</h2>
        <p class="info">Veuillez saisir le nom de la template</p>
        <b-form-input v-model="data.nom"></b-form-input>
      </div>
    </b-container>

    <div slot="modal-footer" class="w-100">
      <div class="footer-action float-right">
        <b-button
          variant="outline-primary"
          size="md"
          class="mx-2"
          @click="close"
        >
          Annuler
        </b-button>
        <b-button variant="primary" size="md" @click="saveChanges">
          Valider
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import iconBase from '../../icons/iconBase'
import { defaultFicheLayout } from '../../../config/constanteUse'
export default {
  components: {
    iconBase
  },
  props: {
    type: {
      type: String,
      default: 'add'
    },
    onglet: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      data: null
    }
  },
  created () {
    if (this.type === 'add') {
      this.data = {
        onglet: this.onglet,
        nom: 'Nouveau template',
        data: { titre: '', elements: [...defaultFicheLayout] }
      }
    }
  },
  methods: {
    close () {
      this.$refs['templateNameModal'].hide()
    },
    open () {
      this.$refs['templateNameModal'].show()
    },
    openEdit (data) {
      this.data = { ...data }
      this.$refs['templateNameModal'].show()
    },
    saveChanges () {
      if (this.type === 'add') {
        this.data.data.titre = this.data.nom
        this.$emit('addTemplate', this.data)
      } else {
        this.$emit('editNom', this.data)
      }
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.text-edit {
  margin-top: 20px;
  width: 100%;
  p.info {
    font-style: italic;
    color: rgba(0, 0, 0, 0.5);
    font-size: 13px;
    text-align: left;
  }
  h2.sub-title {
    margin-top: 30px;
    font-size: 16px;
    font-weight: 600;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/modal/templateFiche.vue